import {ElementsIconProps} from '../components';

export const BackIcon = (props: ElementsIconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.7912 11.005H7.62124L12.5012 6.12496C12.8912 5.73496 12.8912 5.09496 12.5012 4.70496C12.3144 4.51771 12.0608 4.41248 11.7962 4.41248C11.5317 4.41248 11.2781 4.51771 11.0912 4.70496L4.50124 11.295C4.11124 11.685 4.11124 12.315 4.50124 12.705L11.0912 19.295C11.4812 19.685 12.1112 19.685 12.5012 19.295C12.8912 18.905 12.8912 18.275 12.5012 17.885L7.62124 13.005H18.7912C19.3412 13.005 19.7912 12.555 19.7912 12.005C19.7912 11.455 19.3412 11.005 18.7912 11.005Z"
        fill="currentColor"
      />
      <mask
        id="mask0_405_3797"
        style={{ maskType: 'luminance' }}
        maskUnits="userSpaceOnUse"
        x="4"
        y="4"
        width="16"
        height="16"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M18.7912 11.005H7.62124L12.5012 6.12496C12.8912 5.73496 12.8912 5.09496 12.5012 4.70496C12.3144 4.51771 12.0608 4.41248 11.7962 4.41248C11.5317 4.41248 11.2781 4.51771 11.0912 4.70496L4.50124 11.295C4.11124 11.685 4.11124 12.315 4.50124 12.705L11.0912 19.295C11.4812 19.685 12.1112 19.685 12.5012 19.295C12.8912 18.905 12.8912 18.275 12.5012 17.885L7.62124 13.005H18.7912C19.3412 13.005 19.7912 12.555 19.7912 12.005C19.7912 11.455 19.3412 11.005 18.7912 11.005Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_405_3797)"></g>
    </svg>
  );
};
